








































































































































































































































































































import { Component } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import AnnoucementService from "@/services/Annoument.service";
import GenericAdd from "../../core/Generics/GenericAdd";
import Porposal from "@/models/porposal/porposal.model";
import { PorposalModality } from "@/enums/PorposalModality";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProjectTypeService from "@/services/projectType.service";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import GenericEdit from "../../core/Generics/GenericEdit";
import Document from "../../models/document.model";
import ProposedConsortium from "@/models/porposal/proposedConsortium.Model";
import moment from "moment";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import { BudgetItemCalculation } from "@/enums/BudgetItemCalculation";
import AnnoucementAreasService from "@/services/AnnoumentArea.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import ResearchCenterService from "@/services/researchCenter.service";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import DocumentComponentViewer from "@/components/document-component-view/documentComponentViewer.vue";
import UserService from "@/services/user.service";
import PorposalService from "@/services/porposal.service";
//import PorposalDetail from "@/components/porposal-detail-component/detail.vue";
import PorposalDetail from "@/components/porposal-detail-component/detail-optimized.vue";
import { ProposalState } from "@/enums/ProposalState";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import { ParesEvaluadoresTypes } from "@/enums/ParesEvaluadoresTypes";
import ProporsalUsersEvaluators from "@/models/porposal/proporsalUsersEvaluators.Model";
import PreguntaService from "@/services/pregunta.service";
import EvaluacionService from "@/services/Evaluacion.service";
import TipoEvaluacionService from "@/services/TipoEvaluacion.service";
import { AnswerType } from "../../enums/AsnwerType";
import TipoEvaluacion from "../../models/evaluacion/tipoEvaluacion.model";
import Evaluacion from "../../models/evaluacion/evaluacion.model";
import Pregunta from "../../models/evaluacion/pregunta.model";
import PreguntaOpcionRespuesta from "../../models/evaluacion/pregunta-opcion-respuesta";
import RespuestaModel from "../../models/evaluacion/respuesta.model";
import { EvaluationState } from "@/enums/EvaluationState";

@Component({
  components: {
    DatePickerComponent,
    documentcomponent: DocumentComponent,
    ResearchCenterBasicInformationComponent,
    UserBasicInformationComponent,
    DocumentComponentViewer,
    PorposalDetail,
    BaseSelectPerson,
  },
})
export default class ProposalEvaluationDetail extends GenericEdit<Porposal> {
  currentTab = 1;
  memberTypes: any = [];
  projectTypes: any = [];
  isCompletedModalActive: boolean = false;
  showModalEvaluadores: boolean = false;

  areas: any = [];
  motivoDevolucion: string = null;
  accionARealizar: string = null;
  fieldAreas: any = [];
  fieldAreasResearchLines: any = [];
  researchCenter: any = null;
  PorposalModality = PorposalModality;
  PorposalExpectedResult = PorposalExpectedResult;
  projectTypeService: ProjectTypeService = new ProjectTypeService();
  announcementService: AnnoucementService = new AnnoucementService();
  annoucementAreasService: AnnoucementAreasService = new AnnoucementAreasService();
  researchCenterService: ResearchCenterService = new ResearchCenterService();
  userService: UserService = new UserService();
  proposalService: PorposalService = new PorposalService();
  researchCenters = [];
  loading = false;
  Coins: [];
  annoucementId: number | null = null;

  totalBudgetFondocyt: number = 0;
  totalBudgetInstitutionalAport: number = 0;
  showWarning = false;

  fechaEvaluador: any = null;
  fechaEvaluadorCientificoTecnico: any = null;
  fechaEvaluadorFinanciero: any = null;

  paresEvaluadores = [];

  evaluadoresPertinencia = [];
  evaluadoresCientificoTecnico = [];
  evaluadoresFinanciero = [];

  evaluador: any = null;
  evaluadorCientificoTecnico: any = null;
  evaluadorFinanciero: any = null;

  resetPertinenciaSelect: boolean = false;
  resetCientificoTecnicoSelect: boolean = false;
  resetFinancieroSelect: boolean = false;

  pertinenciaType: ParesEvaluadoresTypes = ParesEvaluadoresTypes.PERTINENCIA;
  cientificoTecnicoType: ParesEvaluadoresTypes =
    ParesEvaluadoresTypes.CIENTIFICOTECNICO;
  financieroType: ParesEvaluadoresTypes = ParesEvaluadoresTypes.FINANCIERO;

  textbox: AnswerType = AnswerType.TEXTBOX;
  checkbox: AnswerType = AnswerType.CHECKBOX;
  select: AnswerType = AnswerType.SELECT;

  evaluacionService: EvaluacionService = new EvaluacionService();
  preguntaService: PreguntaService = new PreguntaService();
  tipoEvaluacionService: TipoEvaluacionService = new TipoEvaluacionService();
  formulario: TipoEvaluacion = new TipoEvaluacion();
  evaluacion: Evaluacion = new Evaluacion();
  isApproved: boolean = false;
  motivoEvaluacion: string = "";
  estadoEvaluacionNoAprobada: EvaluationState = EvaluationState.NORECOMENDADA;
  estadoEvaluacionFinal: EvaluationState = null;
  isMainEvaluation: boolean = false;
  estadosEvaluacion = [
    {
      id: EvaluationState.RECOMENDADA,
      name: "RECOMENDADA",
    },
    {
      id: EvaluationState.RECOMENDADACONCONDICION,
      name: "RECOMENDADA CON CONDICION",
    },
    {
      id: EvaluationState.NORECOMENDADA,
      name: "NO RECOMENDADA",
    },
  ];

  delay: any = 700;
  clicks: any = 0;
  timer: any = null;

  get estadoEvaluacionTitle() {
    let title = "";
    if (this.formulario.evaluationState) {
      switch (this.formulario.evaluationState) {
        case EvaluationState.RECOMENDADA:
          title = "RECOMENDADA";
          break;
        case EvaluationState.RECOMENDADACONCONDICION:
          title = "RECOMENDADA CON CONDICION";
          break;
        case EvaluationState.NORECOMENDADA:
          title = "NO RECOMENDADA";
          break;
      }
    }
    return title;
  }

  constructor() {
    super();
    this.controller = "Porposal";
    this.model = new Porposal();
  }

  get tituloFormulario() {
    return this.formulario && this.formulario.titulo
      ? this.formulario.titulo
      : "";
  }

  // evaluacion
  SendEvaluation() {
    this.loading = false;
    let preguntasNoContestadas = [];
    //
    this.formulario.preguntas.forEach((pregunta: Pregunta) => {
      let preguntaContestada = true;
      //
      let respuestasTextBox = pregunta.preguntaOpcionRespuestas.filter(
        (x) => x.tipoRespuesta == this.textbox
      );
      let respuestasCheckBox = pregunta.preguntaOpcionRespuestas.filter(
        (x) => x.tipoRespuesta == this.checkbox
      );
      let respuestasSelect = pregunta.preguntaOpcionRespuestas.filter(
        (x) => x.tipoRespuesta == this.select
      );
      //
      if (
        respuestasTextBox.length > 0 &&
        respuestasTextBox.some((x) => !x.respuesta || x.respuesta == "")
      ) {
        let questionIdentifier = pregunta.titulo + " - " + pregunta.texto;
        preguntaContestada = false;
        if (!preguntasNoContestadas.some((x) => x == questionIdentifier))
          preguntasNoContestadas.push(questionIdentifier);
      }
      //
      if (
        respuestasCheckBox.length > 0 &&
        respuestasCheckBox.every((x) => !x.respuesta)
      ) {
        let questionIdentifier = pregunta.titulo + " - " + pregunta.texto;
        preguntaContestada = false;
        if (!preguntasNoContestadas.some((x) => x == questionIdentifier))
          preguntasNoContestadas.push(questionIdentifier);
      }
      //
      if (respuestasSelect.length > 0 && !pregunta.respuesta) {
        let questionIdentifier = pregunta.titulo + " - " + pregunta.texto;
        preguntaContestada = false;
        if (!preguntasNoContestadas.some((x) => x == questionIdentifier))
          preguntasNoContestadas.push(questionIdentifier);
      }
    });
    //
    if (preguntasNoContestadas.length == 0) {
      if (this.isMainEvaluation && !this.estadoEvaluacionFinal)
        this.operationNoAllowed("Debe seleccionar un estado de evaluacion");
      else this.guardarRespuestas(true, this.estadoEvaluacionFinal);
    } else {
      preguntasNoContestadas.forEach((preguntasNoContestada) => {
        this.operationNoAllowed(
          "Debe contestar la pregunta: " + preguntasNoContestada
        );
      });
    }
  }

  async guardarRespuestas(
    fueCompletada: boolean,
    evaluationState: EvaluationState
  ) {
    this.isCompletedModalActive = false;
    this.loading = true;
    this.evaluacion = this.formulario.evaluacionId
      ? await this.evaluacionService.getById(this.formulario.evaluacionId)
      : new Evaluacion();
    this.evaluacion.userId = this.user.id;
    this.evaluacion.fueCompletada = fueCompletada;
    this.evaluacion.motivoEvaluacion = this.motivoEvaluacion;

    this.evaluacion.isApproved = this.isMainEvaluation
      ? evaluationState == EvaluationState.RECOMENDADA ||
        evaluationState == EvaluationState.RECOMENDADACONCONDICION
        ? true
        : false
      : this.isApproved;
    this.evaluacion.evaluationState = evaluationState;
    this.evaluacion.evaluationTypeId = Number(this.$route.params.tipo);
    this.evaluacion.porposalId = Number(this.$route.params.id);

    if (this.evaluacion.id) {
      this.formulario.preguntas.forEach((pregunta: Pregunta) => {
        pregunta.preguntaOpcionRespuestas.forEach(
          (opcionRespuesta: PreguntaOpcionRespuesta) => {
            let answer = this.evaluacion.respuestas.find(
              (x) =>
                x.preguntaId === opcionRespuesta.preguntaId &&
                x.preguntaOpcionRespuestaId === opcionRespuesta.id
            );
            switch (answer.tipoRespuesta) {
              case this.checkbox:
                answer.valorBool = !!opcionRespuesta.respuesta;
                answer.valorString = opcionRespuesta.valorString;
                break;
              case this.select:
                answer.valorBool = !!(
                  opcionRespuesta.valorString === pregunta.respuesta
                );
                answer.valorString = opcionRespuesta.valorString;
                break;
              case this.textbox:
                answer.valorString = opcionRespuesta.respuesta;
                break;
            }
          }
        );
      });

      this.evaluacionService.update(this.evaluacion).then((response) => {
        if (response) {
          this.$buefy.toast.open({
            message: "Se ha editado su evaluación correctamente",
            type: "is-success",
          });

          this.loading = false;
          this.formulario.fueCompletada = fueCompletada;
          if (this.isMainEvaluation) {
            this.formulario.evaluationState = evaluationState;
          } else {
            this.formulario.isApproved = this.isApproved;
          }
          //this.$router.push(`/proposal-pending-evaluations`);
        }
      });
    } else {
      this.formulario.preguntas.forEach((pregunta: Pregunta) => {
        pregunta.preguntaOpcionRespuestas.forEach(
          (opcionRespuesta: PreguntaOpcionRespuesta) => {
            let respuesta: RespuestaModel = new RespuestaModel();
            respuesta.tipoRespuesta = opcionRespuesta.tipoRespuesta;
            respuesta.preguntaOpcionRespuestaId = opcionRespuesta.id;
            respuesta.preguntaId = opcionRespuesta.preguntaId;
            switch (respuesta.tipoRespuesta) {
              case this.checkbox:
                respuesta.valorBool = !!opcionRespuesta.respuesta;
                respuesta.valorString = opcionRespuesta.valorString;
                break;
              case this.select:
                respuesta.valorBool = !!(
                  opcionRespuesta.valorString === pregunta.respuesta
                );
                respuesta.valorString = opcionRespuesta.valorString;
                break;
              case this.textbox:
                respuesta.valorString = opcionRespuesta.respuesta;
                break;
            }
            this.evaluacion.respuestas.push(respuesta);
          }
        );
      });

      this.evaluacionService.save(this.evaluacion).then((response) => {
        if (response) {
          this.$buefy.toast.open({
            message: "Se ha guardado su evaluación correctamente",
            type: "is-success",
          });
          //this.$router.push(`/proposal-pending-evaluations`);
          this.loading = false;
          this.formulario.fueCompletada = fueCompletada;
          if (this.isMainEvaluation) {
            this.formulario.evaluationState = evaluationState;
          } else {
            this.formulario.isApproved = this.isApproved;
          }

          this.getFormulario();
        }
      });
    }
  }

  get showSidebar() {
    return this.$store.state.showSidebar;
  }

  toggleSidebar() {
    this.$store.commit("set_showSidebar", !this.showSidebar);
  }

  protected async getData() {
    try {
      this.loading = true;

      let response = await this.repository.byId(this.id, this.include);
      if (response.startDate) response.startDate = new Date(response.startDate);
      if (response.endDate) response.endDate = new Date(response.endDate);
      this.model = response;
      this.annoucementId = this.model.annoucementId as number;
      let typeId = Number(this.$route.params.tipo);

      this.isMainEvaluation = await this.announcementService.validateAnnouncementEvaluationTypeByIdAndType(
        this.annoucementId,
        typeId
      );

      this.modelInit = this.map<Porposal>(this.model);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  get user() {
    return this.$store.state.user;
  }

  mounted() {
    this.getFormulario();

    if (this.showSidebar) {
      this.toggleSidebar();
    }
  }

  clickHandled(event) {
    this.loading = true;
    this.clicks++;
    if (this.clicks === 1) {
      var self = this;
      this.timer = setTimeout(function() {
        self.SendEvaluation();
        self.clicks = 0;
      }, this.delay);
    } else {
      clearTimeout(this.timer);
      this.clicks = 0;
    }
  }

  clickUpdateHandled(event) {
    this.loading = true;
    this.clicks++;
    if (this.clicks === 1) {
      var self = this;
      this.timer = setTimeout(function() {
        self.guardarRespuestas(false, self.estadoEvaluacionNoAprobada);
        self.clicks = 0;
      }, this.delay);
    } else {
      clearTimeout(this.timer);
      this.clicks = 0;
    }
  }

  getFormulario() {
    let userId = Number(this.user.id);
    let proposalId = Number(this.$route.params.id);
    let type = Number(this.$route.params.tipo);

    this.tipoEvaluacionService
      .getByUserProposalAndEvaluacionType(userId, proposalId, type)
      .then((response: TipoEvaluacion) => {
        if (response) {
          this.motivoEvaluacion = response.motivo ? response.motivo : "";
          this.formulario = response;
          this.formulario.preguntas.forEach((pregunta) => {
            pregunta.preguntaOpcionRespuestas.forEach((opcionRespuesta) => {
              switch (opcionRespuesta.tipoRespuesta) {
                case this.textbox:
                  opcionRespuesta.respuesta = opcionRespuesta.valorString;
                  break;
                case this.checkbox:
                  opcionRespuesta.respuesta = opcionRespuesta.valorBool;
                  break;
                case this.select:
                  // trabajado en el backend
                  break;
              }
            });
          });
        }
      });
  }

  getEvaluacion() {
    // servira mas adelante
    let proposalId = Number(this.user.id);
    let evaluationTypeId = Number(this.$route.params.tipo);
    this.evaluacionService
      .getByUserAndProposalId(this.user.id, proposalId, evaluationTypeId)
      .then((response) => {
        if (response) {
          alert("yeaaa ehh");
        }
      });
  }
}
